import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: { label: "Idioma" },
  en: { label: "Language" },
});
